/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * What kind of client a connector will use at an MCP server's vendor.
 */
export enum McpServerClientType {
    DCR = 'dcr',
    PRE_REGISTERED = 'pre_registered',
    METADATA_DOCUMENT = 'metadata_document',
}
